import { oc } from '@orpc/contract';
import { idParamSchema } from '../../common/schemas/id.schemas.js';
import { runDetailSchema } from '../schemas/runs.schemas.js';
export const getRunContract = oc
    .route({
    method: 'GET',
    path: '/runs/{id}',
    tags: ['Runs'],
    summary: 'Read one test run with its conditions, measurements, result and per-rule verdicts',
})
    .input(idParamSchema)
    .output(runDetailSchema);
//# sourceMappingURL=get-run.contract.js.map